import clsx from 'clsx';
import React from 'react';
import UserIcon from '../../assets/icons/user-icon.svg?react';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { useLocalStorage } from '@uidotdev/usehooks';
import { LoginResponseData, OrganizationPaymentMethodEnum } from '@EHSNavigator/backend';

interface ConfirmCreateUserModalProps {
  otherClasses?: string;
  formHandler: any;
  isDisable?: boolean;
  handleClose: () => void;
}

const ConfirmCreateUserModal: React.FC<ConfirmCreateUserModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
  isDisable = false,
}) => {
  const confirmCreateUserModalClasses = clsx(otherClasses);
  const [userInfo] = useLocalStorage<LoginResponseData | null>('userInfo', null);
  return (
    <div
      className={confirmCreateUserModalClasses}
      data-testid="confirm-create-user-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <UserIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine">Confirm User Creation?</h4>
        {
          userInfo?.user.org.paymentMethod === OrganizationPaymentMethodEnum.Stripe ? (
            <p className="font-inter-variable text-neutral-tones-text -tracking-text-area text-base leading-5 font-normal lg:text-lg">
              <span>
                Clicking Create User will create the profile and send an email with a link to set the user’s password.
              </span>
              The user costs <span className='text-brand-byzantine'>$25/month</span> and is billed annually, so <span className='text-brand-byzantine'>$300</span> will be charged automatically.
            </p>
          ) : (
            <p className="font-inter-variable text-neutral-tones-text -tracking-text-area text-base leading-5 font-normal lg:text-lg">
              <span>
                Clicking Create User will create the profile and send an email with a link to set the user’s password.
              </span>
            </p>
          )
        }

      </div>
      <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
        <Button
          variant="secondary"
          type="button"
          size={useButtonSizeSmall()}
          onClick={() => handleClose()}
          otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
        >
          Cancel
        </Button>
        <Button
          disable={isDisable}
          onClick={() => formHandler?.handleSubmit()}
          size={useButtonSizeSmall()}
        >
          {isDisable ? 'Please wait' : 'Create User'}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmCreateUserModal;
